function normalizeText(text) {
    return text
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '');
}

export const filterProductsByQuery = (group, query) => {
    if (!query) return group;

    const normalizedQuery = query.toLowerCase();
    const normalizedLabel = normalizeText(group.label);

    if (normalizedLabel.includes(normalizedQuery)) return group;

    const filteredProducts = group.products.filter((product) => {
        const normalizedProductLabel = normalizeText(product.label);
        return normalizedProductLabel.includes(normalizedQuery);
    });

    return {
        ...group,
        products: filteredProducts,
    };
};
